module.exports = __webpack_public_path__ + "media/images/flags/tm-142116714fd7536ffbfbf580bdaf9a9f.svg";